"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _nanoid = require("nanoid");
var FileWrapper = exports["default"] = /*#__PURE__*/function () {
  function FileWrapper(file) {
    (0, _classCallCheck2["default"])(this, FileWrapper);
    this.id = void 0;
    this.file = void 0;
    this.id = (0, _nanoid.nanoid)();
    this.file = file;
  }
  return (0, _createClass2["default"])(FileWrapper, [{
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getFile",
    value: function getFile() {
      return this.file;
    }
  }]);
}();